import { BulbFilled, BulbOutlined, CameraFilled } from "@ant-design/icons";
import { Button, Col, Row, Image, Typography } from "antd";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import CustomButton from "./CustomButton";
import { useLocation } from "react-router-dom";
import dayjs from "dayjs";
import React from "react";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
// import logosrc from "src/statics/shivvers-logo.svg";


const { Text } = Typography;
const textStyle = {
  fontWeight:'bold'
};

interface FooterProps{
  binDto: PremierPlusBinDTO | null | undefined;
}

const Footer : React.FC<FooterProps> = ({ binDto }) => {

    const [currentTime, setCurrentTime] = useState(new Date().toLocaleTimeString());
    const location = useLocation();
    const [disableTroubleshootingButton, setDisableTroubleshootingButton] = useState(false);
  
    useEffect(() => {
      const updateTime = () => setCurrentTime(new Date().toLocaleTimeString());
      updateTime(); 
      const timer = setInterval(updateTime, 60000); 
      return () => clearInterval(timer); 
    }, []);
    
    const footerStyle =  {
      borderTop: `1px solid ${'#d9d9d9'}`,
      paddingTop: 6,
    }

    useEffect( () =>{
      setDisableTroubleshootingButton(location.pathname=== '/drying')
    }, [location.pathname])


    const footerButtons = [
      <CustomButton 
      icon={<CameraFilled />} 
      label={'Camera'}
      disabled={true}
      />,
      
      <CustomButton 
      icon={<BulbFilled />}
      disabled={true}
      />,
    ]
  
    return (
      <Row align={'middle'} justify={'space-between'} style={footerStyle}>
        <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center' }}>
          {/* <Image width={200} src={logosrc} preview={false}/> */}
          <Text style={textStyle}>{`${binDto?.version}-${binDto?.hmiVersion}`}</Text>
        </div>

        <Clock />

        <div style={{ display: 'flex', flexDirection: 'row', gap:'8px', alignItems: 'center' }}> 
          {footerButtons.map( (fb) => fb)}
          <CustomButton 
          label={'TROUBLESHOOTING'} 
          height={39} 
          disabled={true}
          />
        </div>
      </Row>
    );
  };

  export const Clock = () => {
    const [currentTime, setCurrentTime] = useState(new Date());

    useEffect(() => {
      const interval = setInterval(() => setCurrentTime(new Date()), 1000);
      return () => {
        clearInterval(interval);
      };
    }, []);

    return (
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Text style={textStyle}>
          {dayjs(currentTime.toISOString())
            .tz("America/Chicago")
            .format("MM/DD/YYYY hh:mm:ss A")}
        </Text>
      </div>
    );
  };
  

export default Footer;